import {
    SET_RENTING_RED_RAC_LIST,
    REMOVE_RENTING_RED_RAC_VEHICLE,
} from './types';

export const setVehicles = payload => ({
    type: SET_RENTING_RED_RAC_LIST,
    payload,
});

export const removeVehicle = payload => ({
    type: REMOVE_RENTING_RED_RAC_VEHICLE,
    payload,
});
